const hasLineNumbers = (el) => el.classList.contains('line-numbers');

const loadLineNumbers = async () => {
    try {
        await import('prismjs/plugins/line-numbers/prism-line-numbers');
        await import('prismjs/plugins/line-numbers/prism-line-numbers.css');
    } catch (err) {
        console.warn('Failed to load Prism line numbers plugin:', err);
    }
};

export {hasLineNumbers, loadLineNumbers};
